import { Box, SxProps, Theme } from "@mui/material";
import { useTheme } from "../../context/ThemeContext";

export interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  currentTabIndex: number;
  sx?: SxProps<Theme>;
}
export function TabPanel(props: TabPanelProps) {
  const { children, currentTabIndex, index, sx } = props;

  const { theme } = useTheme();
  return (
    <div
      role="tabpanel"
      hidden={currentTabIndex !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={currentTabIndex === index ? { flex: 1, overflow: "hidden", display: "flex", flexDirection: "column" } : undefined}
    >
      {currentTabIndex === index && (
        <Box sx={{ py: theme.spacing(2), flex: 1, overflow: "hidden", display: "flex", flexDirection: "column", ...sx }}>{children}</Box>
      )}
    </div>
  );
}
